import { GtmProvider } from './src/gtm';

export default new GtmProvider();
